import React, { useState, useContext } from "react";
import AuthContext from "../../../contexts/AuthContext";
import styles from "./StoryCreate.module.css";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { useGenres } from "../../Browse/GenreHooks";
import Loading from "../../Loading";
const minLengths = {
  title: 5,
  description: 8,
};

const StoryForm = ({ register, setValue, errors, setRedirect }) => {
  const availableTags = ["default", "horror"];
  const languages = ["English", "Turkish"];
  const submit = React.useRef();
  const [first, setFirst] = useState(true);
  const customFields = ["tags", "characters", "genre", "language"];
  const { genres, loading } = useGenres();

  const handleChange = (e, target) => {
    console.log(Array.isArray(e) ? e.map((elem) => elem.value) : (e ? e.value : null));
    setValue(
      target.name,
      Array.isArray(e) ? e.map((elem) => elem.value) : (e ? e.value : null)
    );
  };

  React.useEffect(() => {
    if (first) {
      setFirst(false);
      customFields.forEach((f) => register(f));
    }
  }, [register, customFields, first]);

  if (loading) {
    return <Loading top={true} />;
  }

  return (
    <div className={styles.form}>
      <Field name={"title"} errors={errors}>
        <input
          className={styles.field}
          ref={register({ required: true, minLength: minLengths.title })}
          type="text"
          name="title"
        />
      </Field>

      <Field name={"description"} errors={errors}>
        <textarea
          className={styles.field}
          style={{ height: 200, resize: "none" }}
          name="description"
          ref={register({ required: true, minLength: minLengths.description })}
        />
      </Field>

      <div className={styles.columns}>
        <div className={styles.column}>
          <Field name={"tags"} errors={errors}>
            <CreatableSelect
              isMulti
              isClearable
              name="tags"
              closeMenuOnSelect={false}
              onChange={handleChange}
              placeholder={"Add Tags"}
              // onInputChange={this.handleInputChange}
              // className={styles.field}
              options={availableTags.map((tag) => ({
                value: tag,
                label: tag,
              }))}
            />
          </Field>

          <div className={styles.label}>Genre</div>
          <Select
            placeholder={"Select Genre"}
            name="genre"
            onChange={handleChange}
            options={genres.map((genre) => ({
              value: genre.genreName,
              label: genre.genreName,
            }))}
          />

          <div className={styles.label}>Language</div>
          <Select
            placeholder={"Select Language"}
            name="language"
            onChange={handleChange}
            options={languages.map((l) => ({
              value: l,
              label: l,
            }))}
          />
        </div>
        <div className={styles.spacer} />
        <div className={styles.column}>
          <div className={styles.label}>Characters</div>

          <CreatableSelect
            isMulti
            isClearable
            isOptionDisabled={true}
            placeholder={"Add Characters"}
            name="characters"
            noOptionsMessage={() => "Start typing to create new Character"}
            onChange={handleChange}
            // className={styles.field}
          />

          {/* <div className={styles.label}>Status</div> */}
          <Field name={"storyStatus"} errors={errors}>
            <div className={styles.fields}>
              <div>
                <input
                  type="radio"
                  name="storyStatus"
                  ref={register({ required: true })}
                  value={"Ongoing"}
                />{" "}
                Ongoing
              </div>
              <div>
                <input
                  type="radio"
                  name="storyStatus"
                  ref={register({ required: true })}
                  value={"Completed"}
                />{" "}
                Completed
              </div>
            </div>
          </Field>
        </div>
      </div>
      <div>
        <input
          type="submit"
          className={styles.submit}
          onClick={() => setRedirect("episode")}
          value={"Save and add episode"}
        ></input>
        <input
          type="submit"
          className={styles.submit}
          onClick={() => setRedirect("story")}
          value={"Save"}
        ></input>
      </div>
      {/* <input type="submit" ref={submit} style={{ display: "none" }} /> */}
    </div>
  );
};

const Field = ({ children, name, errors }) => {
  const getErrorText = (error) => {
    const name = error.ref.name;

    if (error.type === "required") {
      return `${name} is required`;
    } else if (error.type === "minLength") {
      return `${name} has to be atleast ${minLengths[name]} letters long`;
    }
  };

  return (
    <div
      className={
        errors[name] ? styles.errors + " " + styles.formItem : styles.formItem
      }
    >
      <div className={styles.label}>{name}</div>
      {children}
      <div className={styles.error}>
        {errors[name] ? getErrorText(errors[name]) : ""}
      </div>
    </div>
  );
};

export default StoryForm;
